import {ChangeDetectionStrategy, Component, inject, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiError} from "../../../../../core/models/api-error.model";
import {Hardware} from "../../../../../core/models/hardware.model";
import {FormControl, FormGroup} from "@angular/forms";
import {AdminCommunityService} from "../../../../../core/services/admin/admin-community.service";
import {Community} from "../../../../../core/models/community.model";
import {HardwareFormComponent} from '../../components/hardware-form/hardware-form.component';

@Component({
  templateUrl: './manage-hardware.dialog.html',
  styleUrls: ['./manage-hardware.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ManageHardwareDialog implements OnInit {

  @ViewChild('hardwareFormComponent')
  hardwareFormComponent!: HardwareFormComponent;

  readonly #communityService = inject(AdminCommunityService);

  private readonly _dialogRef: MatDialogRef<ManageHardwareDialog>;
  private readonly _hardware: Hardware;
  private readonly _community: Community;
  private _hardwareForm!: FormGroup;
  private _error: ApiError | null = null;
  private _isLoading: boolean = false;

  constructor(dialogRef: MatDialogRef<ManageHardwareDialog>, @Inject(MAT_DIALOG_DATA) data: any) {
    this._dialogRef = dialogRef;
    this._hardware = data.hardware;
    this._community = data.community;
  }

  ngOnInit() {
    this._hardwareForm = new FormGroup({
      availableHardware: new FormControl(null, []),
    });
  }

  get hardwareForm(): FormGroup {
    return this._hardwareForm;
  }

  get error(): ApiError | null {
    return this._error;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  public onClose(): void {
    this._dialogRef.close(false);
  }

  public submit(): void {
    console.log({form: this.hardwareForm});

    if (this.hardwareForm.valid && !this._isLoading) {
      this._isLoading = true;
      this._error = null;
      const hardwareId = this.hardwareForm.get('availableHardware')?.value;

      if (hardwareId === this.hardwareFormComponent.NONE_VALUE) {
        this.#communityService.removeHardware(this._community.id).subscribe({
          next: (response) => {
            this._dialogRef.close(true);
            this._isLoading = false;
          },
          error: (error) => {
            this._error = error.error;
            this._isLoading = false;
          }
        });
      } else {
        this.#communityService.changeHardware(this._community.id, hardwareId).subscribe({
          next: (response) => {
            this._dialogRef.close(true);
            this._isLoading = false;
          },
          error: (error) => {
            this._error = error.error;
            this._isLoading = false;
          }
        });
      }
    }
  }
}
